import { createSelector } from 'reselect';
import { getFormValues } from 'redux-form';

import { filterByString } from '@topconagriculture/frontend-utils';

import { RootState } from '../../reducers';
import { Zone, ZoneExtended } from './zones.types';
import { Forms, SearchFormFields } from '../../form/form.selector';
import { trimWhitespace } from '../../../core/helpers/utils/utils';
import { getAllGroups } from '../group/group.selector';
import { getMixersList } from '../mixers/mixers.selector';

export const getZonesList = (state: RootState): Zone[] => state.entities.zones;

export const getZonesExtendedList = createSelector(
  [getZonesList, getAllGroups, getMixersList],
  (zones, groups, mixers) =>
    zones.map((x) => ({
      ...x,
      groups: (x.groupIds || []).map((id) => groups.find((g) => g.id === id)!).filter((g) => !!g),
      mixers: (x.mixerIds || []).map((id) => mixers.find((m) => m.id === id)!).filter((m) => !!m),
    })),
);

export const getMixerZones = createSelector(
  [getMixersList, getZonesExtendedList, (state, id: string) => id],
  (mixers, zones, id) => {
    const mixer = mixers.find((mixer) => mixer.id === id);
    return zones.filter((zone) => mixer?.zoneIdList?.includes(zone.id));
  },
);

const zonesFilterFormSelector = getFormValues(Forms.zonesSearch) as () => SearchFormFields;

export const getZoneById = createSelector(
  [getZonesExtendedList, (state: RootState, id: string) => id],
  (zones, zoneId: string) => zones.find((elem) => elem.id === zoneId),
);

export const getZonesListFilteredBySearch = createSelector(
  [getZonesExtendedList, zonesFilterFormSelector],
  (zonesList, filterFormValues: SearchFormFields): ZoneExtended[] => {
    return filterFormValues
      ? zonesList.filter((zone) => {
          const searchString = trimWhitespace(filterFormValues.search);
          const filteredGroups = zone.groups.filter((group) => filterByString(group.displayName, searchString));
          const filteredMixers = zone.mixers.filter((mixer) => filterByString(mixer.displayName, searchString));
          const matchesName = filterByString(zone.description, searchString);
          return matchesName || filteredGroups.length > 0 || filteredMixers.length > 0;
        })
      : zonesList;
  },
);

export const getNotAvailableNumbers = createSelector([getZonesExtendedList], (zones) =>
  zones.map((zone) => zone.zoneNumber),
);
